import React, { memo, useMemo } from 'react'
import Typography from 'transfix-ui/core/Typography'
import { BookableShipmentSavedSearch } from 'apps/fleet-planner/types'
import { getRate, getEquipment, getPickup } from '../utils'

const DELIMITER = '  ·  '

export interface ILaneDetailsProps
  extends Pick<
    BookableShipmentSavedSearch,
    'pickupIsoDaysOfWeek' | 'pickupStartDate' | 'rate' | 'rateType' | 'trailerType'
  > {}

const LaneDetails = memo<ILaneDetailsProps>(
  ({ pickupIsoDaysOfWeek, pickupStartDate, rate, rateType, trailerType }) => {
    const laneDetails = useMemo(() => {
      return [
        getRate({ rate, rateType }),
        getEquipment({ trailerType }),
        getPickup({
          pickupIsoDaysOfWeek,
          pickupStartDate,
        }),
      ].join(DELIMITER)
    }, [pickupIsoDaysOfWeek, pickupStartDate, rate, rateType, trailerType])

    return (
      <Typography variant='body2' component='div' data-test='saved-lane-details'>
        {laneDetails}
      </Typography>
    )
  }
)

export default LaneDetails
